import React from "react";
import { FiChevronDown, FiSearch } from "react-icons/fi";
import { RiArrowRightSLine } from "react-icons/ri";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import parse from "html-react-parser";
import { faqSearch } from "../utils/api";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
// import { useJitsu } from "@jitsu/react";

function FAQSection({
  helpArticles,
  setHelpArticles,
  setFAQSectionActive,
  searchTerm,
  setSearchTerm,
  settings,
}) {
  // const { track } = useJitsu();
  return (
    <div>
      <div className="px-5 pt-4 pb-2">
        <div className="relative mb-5">
          <input
            type="text"
            placeholder="Search articles, keywords, etc."
            className="rounded-xl w-full p-3 text-sm"
            style={{ border: "1px solid #DFE0E1" }}
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                // track("faq_search");
                faqSearch(searchTerm, settings.merchant.id).then((resp) => {
                  setFAQSectionActive(true);
                  setHelpArticles(resp.data.data);
                });
              }
            }}
          />
          <FiSearch
            className="absolute right-4 top-2 mt-2 cursor-pointer"
            onClick={() => {
              // track("faq_search");
              faqSearch(searchTerm, settings.merchant.id).then((resp) => {
                setFAQSectionActive(true);
                setHelpArticles(resp.data.data);
              });
            }}
          />

          {settings.help_center_keywords.length > 0 && (
            <CarouselProvider
              naturalSlideWidth={100}
              naturalSlideHeight={20}
              totalSlides={settings.help_center_keywords.length}
              visibleSlides={3}
            >
              <div className="relative my-4">
                <Slider>
                  {settings.help_center_keywords.map((keyword, i) => {
                    return (
                      <Slide
                        index={i}
                        className="text-xs cursor-pointer text-center"
                        style={{
                          color: settings["--site-widget-primary-color"],
                        }}
                      >
                        <span
                          className="rounded-lg py-1 px-2"
                          style={{
                            background:
                              settings["--site-widget-primary-color-20"],
                          }}
                        >
                          {keyword}
                        </span>
                      </Slide>
                    );
                  })}
                </Slider>
                <ButtonBack
                  className="absolute left-0"
                  style={{ top: "50%", transform: "translateY(-50%)" }}
                >
                  <FaAngleLeft
                    color={settings["--site-widget-primary-color"]}
                  />
                </ButtonBack>
                <ButtonNext
                  className="absolute right-0"
                  style={{ top: "50%", transform: "translateY(-50%)" }}
                >
                  <FaAngleRight
                    color={settings["--site-widget-primary-color"]}
                  />
                </ButtonNext>
              </div>
            </CarouselProvider>
          )}
        </div>

        <Accordion allowZeroExpanded className="border-0">
          {helpArticles
            .filter((article) => {
              var content = String(parse(article.content));
              if (searchTerm === "") {
                return true;
              } else if (
                article.title
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()) ||
                content.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            })
            .map((item) => (
              <AccordionItem key={item.id} className="my-2">
                <AccordionItemHeading>
                  <AccordionItemButton className="flex items-center px-1 text-sm">
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="flex items-center">
                            <FiChevronDown className="mr-2" />
                          </div>
                        ) : (
                          <div className="flex items-center">
                            <RiArrowRightSLine className="mr-2" />
                          </div>
                        )
                      }
                    </AccordionItemState>
                    <p>{item.title}</p>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="text-xs mt-2 px-7">
                  {parse(item.content)}
                </AccordionItemPanel>
                <hr className="my-2" />
              </AccordionItem>
            ))}
        </Accordion>
      </div>
    </div>
  );
}

export default FAQSection;
